import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DomStyleService {
	// configure tailwind theme
	public applyThemeColours(colours: typeof environment.colors): void {
		const rootStyle = document.documentElement.style;

		rootStyle.setProperty('--primary-color0', colours.primary0);
		rootStyle.setProperty('--primary-color', colours.primary);
		rootStyle.setProperty('--primary-color2', colours.primary2);
		rootStyle.setProperty('--primary-color3', colours.primary3);
		rootStyle.setProperty('--primary-color5', colours.primary5);
		rootStyle.setProperty('--accent-white', colours.accentWhite);
		rootStyle.setProperty('--accent-color1', colours.accent1);
		rootStyle.setProperty('--accent-color2', colours.accent2);
		rootStyle.setProperty('--light-primary-color', colours.lightPrimary);
	}
}